import { gql, TypedDocumentNode } from "@apollo/client";

export interface EventSearchNode {
  id: string;
  title: string;
  slug: string;
  status: string;
  startsAt: string;
  endsAt: string;
  city?: string | null;
  state?: string | null;
  facility?: { id: string; name: string } | null;
}

export interface EventsForReferenceSearchResponse {
  events: {
    edges: { node: EventSearchNode }[];
  };
}

export interface EventsForReferenceSearchVariables {
  query?: { title?: string };
  first?: number;
}

export const EVENTS_FOR_REFERENCE_SEARCH_QUERY: TypedDocumentNode<
  EventsForReferenceSearchResponse,
  EventsForReferenceSearchVariables
> = gql`
  query EventsForReferenceSearch($query: BackofficeEventsSearchInput, $first: Int) {
    events(query: $query, first: $first) {
      edges {
        node {
          id
          title
          slug
          status
          startsAt
          endsAt
          city
          state
          facility {
            id
            name
          }
        }
      }
    }
  }
`;
